import { styled } from '@mui/system'
import { Box } from '@mui/material'
import type { Theme } from '@mui/material/styles'
import { blue, shade } from '../../../colors'

interface WrapperProps {
  theme?: Theme
}

export const Wrapper = styled(Box)<WrapperProps>(({ theme }) => ({
  width: '100%',
  minHeight: theme.spacing(80),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}))

interface ImageWrapperProps {
  theme?: Theme
  searchText?: string | null
}

export const ImageWrapper = styled(Box)<ImageWrapperProps>(({ theme, searchText }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: theme.spacing(12),
  height: theme.spacing(12),
  borderRadius: '50%',
  background: searchText ? shade[200] : blue[100],
  marginBottom: theme.spacing(3)
}))
